import React from 'react';
import styled, { css } from 'styled-components';
import { minBreakpointQuery, sectionMargins } from '../styles';
import { Container, Heading, Button } from './ui';
import LocationMap from './LocationMap';
import SpaGroup from './SpaGroup';

const StyledSpaLocationGroup = styled.section`
  ${sectionMargins()};
`;

const StyledHeading = styled(Heading)`
  margin-bottom: 20px;

  ${minBreakpointQuery.small`
    margin-bottom: 25px;
  `}

  ${minBreakpointQuery.large`
    margin-bottom: 30px;
  `}
`;

const StyledInner = styled.div`
  ${({ hasSpaGroup }) => {
    if (hasSpaGroup) {
      return css`
        display: grid;
        gap: 20px;

        ${minBreakpointQuery.smedium`
          grid-template-columns: repeat(2, 1fr);
        `}

        ${minBreakpointQuery.mlarge`
          grid-template-columns: 3fr 2fr;
        `}
      `;
    }
  }}
`;

const StyledButtonWrapper = styled.div`
  margin-top: 20px;
  text-align: center;

  ${minBreakpointQuery.small`
    margin-top: 25px;
  `}

  ${minBreakpointQuery.large`
    margin-top: 30px;
  `}
`;

const StyledButton = styled(Button)`
  span {
    padding-right: 0;
    padding-left: 24px;

    &:after {
      right: auto;
      left: 0;
      transform: translateY(-50%) rotate(180deg);
    }
  }

  &:hover {
    span {
      &:after {
        transform: translateX(-3px) translateY(-50%) rotate(180deg);
      }
    }
  }
`;

const SpaLocationGroup = ({ spa, spaPackageName, spaGroup }) => (
  <StyledSpaLocationGroup>
    <Container narrow={!spaGroup}>
      <StyledHeading alt={true}>Spa Location</StyledHeading>
      <StyledInner hasSpaGroup={spaGroup}>
        <LocationMap
          locations={[
            {
              name: spa.name,
              nameWithLocation: spa.nameWithLocation,
              address: `<p>${Object.values(spa.address)
                .filter(Boolean)
                .join('<br /> ')}</p>`,
              location: spa.location,
            },
          ]}
          marker={'icon'}
          isSpaLocationGroup={true}
        />
        {spaGroup && (
          <SpaGroup
            logo={
              spaGroup.images &&
              spaGroup.images.find(({ role }) => role === 'logo')
            }
            name={spaGroup.name}
            text={
              spaPackageName &&
              `The '${spaPackageName}' is available at other ${spaGroup.name} venues.`
            }
            url={spaGroup.url || spaGroup.seo.url}
          />
        )}
      </StyledInner>
      {spa.url && (
        <StyledButtonWrapper>
          <StyledButton to={spa.url} arrow={true}>
            Back to '{spa.name}'
          </StyledButton>
        </StyledButtonWrapper>
      )}
    </Container>
  </StyledSpaLocationGroup>
);

export default SpaLocationGroup;
